import React from 'react';

class Employee extends React.Component{


    render(){

        let background={
            color:"whitesmoke",
            backgroundImage:"url(http://khula.co.za/images/veggieback2.png)"
        }

        return (

     <div className="empcontainer" style={{paddingLeft:"5rem",paddingRight:"5rem",paddingTop:"1rem",textAlign:"center"}}>
         <h3>KHULA is hiring! Available jobs are:</h3>
         <div className="row" style={{boxShadow:"2px 2px 2px 2px lightgrey",backgroundColor:"white"}}>
             <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style={background}>
                 <div style={{padding:"0.5rem"}}>
                     <img alt="icon" src="http://dashboard.khula.co.za/images/gears1.png"/>
                 </div>
             </div>
             <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style={background}>
                 <div style={{textAlign:"center",paddingTop:"0.5rem",borderBottom:"1px solid lightgrey"}}>
                     <h3>Operations Manager</h3>
                 </div>
             </div>
             <div className="col-xs-5 col-sm-5 col-md-5 col-lg-4 col-xl-4" style={{borderRight:"1px solid lightgrey"}}>
                 <div style={{textAlign:"right",padding:"1rem"}}>
                     <h5>Key skills:</h5>
                     <p>Dealing with people </p>
                     <p>Client facing </p>
                     <p>Project management </p>
                     <p>written and verbal communication </p>
                     <p>HR</p>
                 </div>
             </div>
             <div className="col-xs-7 col-sm-7 col-md-7 col-lg-8 col-xl-8" >
                 <div style={{textAlign:"left",padding:"1rem"}}>
                     <h5>Job Description:</h5>
                     <p>We are looking for an Operations Manager who can aksdjbcskdjcksdjncksjdnckjsndcksndcjknsdkcn superndklsfnldknflsknfdlknsflknsdlknfslkdnflsknfdlknflsknfldsnflksndlknflskndklfnl
                     <br/>
                         <br/>
                         The job will entail djfksbndkfjnsdjfnlsknflsdknflskndlfksnlfdknslfknsdlkfmsldnf
                         <br/>
                         <br/>
                         We are looking for the person to join sjdfksdjbnfksndfsndf
                         <br/>
                         <br/>


                     </p>

                 </div>
             </div>

         </div>

             <div className="row" style={{boxShadow:"2px 2px 2px 2px lightgrey",backgroundColor:"white", marginTop:"1rem"}}>
             <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style={background}>
                 <div style={{padding:"0.5rem"}}>
                     <img alt="icon" src="http://khula.co.za/images/estate-agent.png"/>
                 </div>
             </div>
             <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style={background}>
                 <div style={{textAlign:"center",paddingTop:"0.5rem",borderBottom:"1px solid lightgrey"}}>
                     <h3>Sales Representative</h3>
                 </div>
             </div>
             <div className="col-xs-5 col-sm-5 col-md-5 col-lg-4 col-xl-4" style={{borderRight:"1px solid lightgrey"}}>
                 <div style={{textAlign:"right",padding:"1rem"}}>
                     <h5>Key skills:</h5>
                     <p>Direct selling</p>
                     <p>Selling agriculture products</p>
                     <p>Selling software solutions</p>
                     <p>Client facing </p>
                     <p>Travelling</p>
                     <p>written and verbal communication </p>
                 </div>
             </div>
             <div className="col-xs-7 col-sm-7 col-md-7 col-lg-8 col-xl-8" >
                 <div style={{textAlign:"left",padding:"1rem"}}>
                     <h5>Job Description:</h5>
                     <p>We are looking for an Operations Manager who can aksdjbcskdjcksdjncksjdnckjsndcksndcjknsdkcn superndklsfnldknflsknfdlknsflknsdlknfslkdnflsknfdlknflsknfldsnflksndlknflskndklfnl
                         <br/>
                         <br/>
                         The job will entail djfksbndkfjnsdjfnlsknflsdknflskndlfksnlfdknslfknsdlkfmsldnf
                         <br/>
                         <br/>
                         We are looking for the person to join sjdfksdjbnfksndfsndf
                         <br/>
                         <br/>


                     </p>

                 </div>
             </div>

         </div>


     </div>

        )
    }
}

export default Employee;


// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/Employee.js